document.addEventListener('DOMContentLoaded', function () {
    populateDeliveryGroups();
    //carousell
    var splide = new Splide('.splide', {
        type: 'loop',
        perPage: 3,
        speed: 300,
        pauseOnHover: false,
        pauseOnFocus: false,
        breakpoints: {
            769: {
                perPage: 2,
            }
        },
        focus: 'center',
        autoplay: true,
        interval: 2000,
        pagination: false,
    });
    splide.mount();

    const buttons = document.querySelectorAll('[data-open-modal]')
    const modal = document.querySelector('.x-mas-modal--container')
    const modalAllSteps = modal.querySelectorAll('[data-step]')
    const proteinStep = modal.querySelector('[data-step="protein"]')
    const datesStep = modal.querySelector('[data-step="dates"]')
    const dataStepContinue = modal.querySelector('.dates.continue')
    const messageStep = modal.querySelector('[data-step="message"]')
    const confirmationStep = modal.querySelector('[data-step="confirmation"]')
    const proteinButtons = document.querySelectorAll('.protein-group button')
    const proteinContinueButton = document.querySelector('.protein.continue')
    const modalClose = modal.querySelector('.modal-close')

    modalClose.addEventListener('click', function () {
        modal.classList.remove('is-active')
        document.body.classList.remove('modal-open')
        modalAllSteps.forEach(step => {
            step.classList.remove('active')
        })
        clearAllProteinSelection()
        proteinContinueButton.disabled = true
        proteinStep.classList.add('active')
    })

    buttons.forEach(button => {
        button.addEventListener('click', function () {
            window.pagesense = window.pagesense || [];
            window.pagesense.push(['trackEvent', 'Select One Package']);
            modal.classList.add('is-active')
            modal.dataset.productId = button.dataset.openModal
            const product_title = button.dataset.productName
            modal.dataset.productName = product_title
            if (product_title === "one-month-trial-vegan") {
                proteinStep.classList.remove('active')
                datesStep.classList.add('active')
            }
            modal.querySelector("h2.product-name").innerHTML = product_title + " KIT"
            document.body.classList.add('modal-open')
        })
    })
    proteinButtons.forEach(button => {
        button.addEventListener('click', function () {
            button.classList.toggle('selected')
            const proteinSelection = getProteinSelection()
            if (proteinSelection.selected.length === 0) {
                proteinContinueButton.disabled = true
            } else {
                proteinContinueButton.disabled = false
            }
        })
    })
    proteinContinueButton.addEventListener('click', function () {
        modalAllSteps.forEach(step => {
            step.classList.remove('active')
        })
        datesStep.classList.add('active')
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'one-month-proteins']);
    })

    datesStep.querySelectorAll('input').forEach(input => {
        input.addEventListener('change', function () {
            const dateSelection = getSelectedDate()
            if (dateSelection) {
                dataStepContinue.disabled = false
            } else {
                dataStepContinue.disabled = true
            }
        })
    })
    dataStepContinue.addEventListener('click', function () {
        modalAllSteps.forEach(step => {
            step.classList.remove('active')
        })
        confirmationStep.classList.add('active')
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'one-month-date']);
    })

    messageStep.querySelector("button.continue").addEventListener('click', function () {
        if (verifyMessage()) {
            modalAllSteps.forEach(step => {
                step.classList.remove('active')
            })
            confirmationStep.classList.add('active')
        }
    })

    confirmationStep.querySelector("button.continue").addEventListener('click', async function () {
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'one-month-checkout-click']);
        const dateSelection = getSelectedDate()
        const proteinSelection = getProteinSelection()
        const message = messageStep.querySelector('textarea').value
        const recipient = messageStep.querySelector('input').value
        const productId = modal.dataset.productId
        const productName = modal.dataset.productName
        const variantId = modal.dataset.variantId
        console.log({ dateSelection, proteinSelection, message, recipient, productId })
        const props = {
            "_Delivery-Group": dateSelection['group-number'],
            "_One-Month-Trial": "true",
        }
        const notSelectedProteins = proteinSelection.notSelected.length > 0 ? proteinSelection.notSelected : false
        if (notSelectedProteins) {
            notSelectedProteins.forEach(protein => {
                props["_restriction_" + protein] = true
            })
        }
        if (productName != "one-month-trial-vegan") {
            props["_restriction_vegan"] = true
        }
        if (message.length > 0) {
            props["_message"] = message
        }
        if (recipient.length > 0) {
            props["_recipient"] = recipient
        }
        const data = {
            items: [
                {
                    'id': productId,
                    'quantity': 1,
                    "properties": props
                }
            ],
            attributes: {
                "Checkout-Method": "delivery",
            }
        }
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
            });
            const json = await response.json();
            window.location.href = '/checkout?locale=en-US&method=delivery';
        } catch (error) {
            console.error(error);
        }
    })

})
function clearAllProteinSelection() {
    const proteinButtons = document.querySelectorAll('.protein-group button')
    proteinButtons.forEach(button => {
        button.classList.remove('selected')
    })
}
function verifyMessage() {
    const modal = document.querySelector('.x-mas-modal--container')
    const messageStep = modal.querySelector('[data-step="message"]')
    const message = messageStep.querySelector('textarea').value
    const recipient = messageStep.querySelector('input').value
    // verifica se tem mensagem, se tive verifica se é menor que 500 ch
    // verifica se tem nome do destinatario
    // se tiver tudo certo, habilita o botao de continuar
    if (message.length > 0) {
        if (message.length < 500) {
            if (recipient.length > 0) {
                return true
            } else {
                alert('Please, enter the recipient name.')
                return false
            }
        } else {
            alert('Your message is too long. Please, shorten it.')
            return false
        }
    }
    return true;
}

function getProteinSelection() {
    const proteinButtons = document.querySelectorAll('.protein-group button')
    let proteinSelection = { selected: [], notSelected: [] }
    proteinButtons.forEach(button => {
        if (button.classList.contains('selected')) {
            proteinSelection.selected.push(button.dataset.protein)
        } else {
            proteinSelection.notSelected.push(button.dataset.protein)
        }
    })
    return proteinSelection
}

function getSelectedDate() {
    const date = document.querySelector('.delivery-groups input:checked')
    if (date) {
        return {
            'start-date': date.dataset.startDate,
            'group-number': date.value,
            'timestamp': parseFloat(date.id),
        }
    } else {
        return false
    }
}

function populateDeliveryGroups() {
    function getNumberWithOrdinal(n) {
        var s = ['th', 'st', 'nd', 'rd'],
            v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    const active_groups = activeDeliveryGroups();
    let content = '';

    active_groups.forEach((group, index) => {
        const date = group.delivery; // Converting to Luxon DateTime
        const startDate = date.setLocale('en').toFormat('EEEE - LLL dd, yyyy');
        const wrap = `
        <div class="input-wrapper">
          <label for="${date.toMillis()}">
            <b><i class="fa-regular fa-calendar"></i> ${startDate}</b>
          </label>
          <input
            type="radio"
            name="starting-on"
            id="${date.toMillis()}"
            data-start-date='${startDate}' value="${group.number}"
          >
        </div>`;

        content = content + wrap;
    });

    document.querySelector('.delivery-groups').innerHTML = content;
}

function activeDeliveryGroups() {
    const system_date = luxon.DateTime.now().setZone('America/Toronto');
    const groups = [];
    const startDate = luxon.DateTime.fromISO('2025-01-19T00:00:00', { zone: 'America/Toronto' });
    const deadlineDate = luxon.DateTime.fromISO('2025-01-17T09:59:59', { zone: 'America/Toronto' });

    for (let i = 0; i < 51; i++) {
        groups.push({
            number: i + 1,
            delivery: startDate.plus({ weeks: i }),
            deadline: deadlineDate.plus({ weeks: i }),
        });
    }
    groups.forEach((group) => {
        if (group.deadline > system_date) {
            group.active = true;
        } else {
            group.active = false;
        }
    });
    const activeGroups = groups.filter((group) => group.active);
    //sort by date
    activeGroups.sort((a, b) => a.delivery - b.delivery);
    return activeGroups.slice(0, 4);
}


function checkElementVisibility() {
    const elementX = document.querySelector('.products---wrapper');
    const elementXRect = elementX.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (elementXRect.top < windowHeight && elementXRect.bottom >= 0) {
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'Choose the package section']);
        window.removeEventListener('scroll', checkElementVisibility);
    }
}

window.addEventListener('scroll', checkElementVisibility);
